import { Route } from '@angular/router';
import { shareOfVoice } from './share-of-voice';
import { SbIcons } from '@ngx-seatback/icons';
import { RoutingID } from '../../../sb-routing-enum';
import { advertiserShareOfVoice } from './share-of-voice-new';

export const content: Route = {
  path: 'content-reporting',
  title: 'nav.reporting.content',
  data: {
    icon: SbIcons.screenPlay,
    breadcrumb: 'nav.reporting.content',
  },
  children: [shareOfVoice, advertiserShareOfVoice, { path: '', redirectTo: RoutingID.advertiserShareOfVoice, pathMatch: 'full' }],
};
